import type { App } from 'vue'
import Vue3ColorPicker from 'vue3-colorpicker'
import 'vue3-colorpicker/style.css'

export default function (app: App) {
  app.use(Vue3ColorPicker)
}
